import { ItemClienteOrigem } from '../generated/backend-enums.js';
export { ItemClienteOrigem };
export const ItemClienteOrigemMap = {
    [ItemClienteOrigem.PLANILHA]: 'Planilha',
};
